import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

import { Ticket } from '@app/modules/model/ticket';
import { PlaceService } from '@app/modules/model/svcplace';
import { PrintDevice } from '@app/modules/model/printer';

import { languageService, languageSupport } from '@app/modules/common/language';
import { deviceService } from '@app/modules/sockets';
import { syncService } from '@app/modules/sync';
import { viewService } from '@app/modules/view';

/************************************/
/* TICKET MODAL                     */
/************************************/

@Component({
    selector: 'modal-toprinter',
    templateUrl:'ui-toprinter-modal.html',
    styleUrls: [ 
        'ui-toprinter-modal.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiToPrintertModal extends languageSupport implements OnInit, OnDestroy {
    public _ticket: Ticket = null;

    private get _place(){
        if (this._ticket){
            return this._ticket.place;
        }
        return null;
    }

    get MultiplePOS(){
        return this._place.MultiplePOS;
    }

    PrinterTill(_printer){
        return _printer.rasppi?.name || null;
    }

    get Printers(){
        let _printers = [];

        for (let _service of this._place.services){
            if (_service.IsValid){
                for(let _printer of _service.printers){
                    if (_printer.IsValid){
                        _printers.push(_printer);
                    }
                }
            }
        }

        return _printers;
    }

    get Terminals(){
        let _terminals = [];

        for (let _service of this._place.services){
            if (_service.IsValid){
                for(let _terminal of _service.payment_terminals){
                    if (_terminal.status == 'AC'){
                        _terminals.push(_terminal);
                    }
                }
            }
        }

        return _terminals;
    }

    TerminalTill(_terminal){
        return _terminal.rasppi?.name || null;
    }

    private _onlinemap = new Map <PrintDevice, string> ();
    IsOnline(_printer){
        if (this._onlinemap.has(_printer)){
            return this._onlinemap.get(_printer);
        }

        return 'WAITING';
    }

    /****************************/
    /* STARTS HERE              */
    /****************************/

    private _check_interval = null;
    private _check_ticksecs = 0;    // check every 5 seconds

    constructor(lang: languageService, private change: ChangeDetectorRef, private modalCtrl: ModalController, private params: NavParams, private sync: syncService, private devsvc: deviceService, public view: viewService) {
        super(lang, change);
    }

    private RunCheck(){
        this._CheckStatus();

        if (this._check_interval == null){
            this._check_interval = this.sync.Clock.OnOneSecondTick.subscribe(
            data => {
                this._check_ticksecs = (this._check_ticksecs + 1) % 5;
                if (this._check_ticksecs == 0){
                    this._CheckStatus();
                }
            });
        }
    }
    
    ngOnInit(){
        this._ticket = this.params.get('ticket');
        this.RunCheck();
    }
    
    ngOnDestroy(){
        super.OnDestroy();

        if (this._check_interval){
            this._check_interval.unsubscribe();
            this._check_interval = null;
        }        
    }

    OnClose(){
        this.modalCtrl.dismiss(null);
    }

    /****************************/
    /* EVENT HANDLERS           */
    /****************************/

    ToPrinter(_printer){
        this._ticket.ToPrinter(_printer);
        this.OnClose();
    }

    ToTerminal(_terminal){
        this._ticket.ToPaytefPrinter(_terminal);
        this.OnClose();
    }

    /* SERVICE STATUS CHECK */

    private _CheckStatus(){
        let _services = new Set <PlaceService> ();

        let _printers = this.Printers;
        for (let _printer of _printers){
            _services.add(_printer.rasppi);
        }

        for (let _service of _services){
            this.devsvc.Test(null, null, _service.name, false).then(
            _connection => {
                let _isonline = !!_connection;
                let _toupdate = (_service.IsOnline != _isonline);
                
                _service.IsOnline = _isonline;
                for(let _printer of _service.printers){
                    if (_printers.includes(_printer)){
                        if (!this._onlinemap.has(_printer)){
                            _toupdate = true;
                        }

                        this._onlinemap.set(_printer, _isonline ? 'ONLINE' : 'OFFLINE' );
                    }
                }

                if (_toupdate){
                    this.change.markForCheck();
                }
            });
        }
    }
}
